import * as Actions from "./_ActionTypes";
import * as Pre from "./_PreActionNames";

export function getList(page, size, accessToken, buildingId) {
  var newMessagesOnly = false;
  //var lang = "fa";
  return {
    type: Pre.USERMESSAGE + Actions.ALL,
    payload: { page, size, newMessagesOnly, buildingId },
    accessToken,
    socket: { send: true, keepSocket: true },
    url: `/UserMessages/List?page=${page}&size=${size}&newMessagesOnly=${newMessagesOnly}&buildingId=${buildingId}`, //&lang=${lang}
  };
}

export function markAsSeen(messageId, accessToken, buildingId) {
  return {
    type: Pre.USERMESSAGE + Actions.MARK_AS_SEEN,
    payload: messageId,
    accessToken,
    socket: { send: true, keepSocket: true },
    url: `/UserMessages/MarkAsSeen?messageId=${messageId}&buildingId=${buildingId}`,
  };
}

export function markAllAsSeen(accessToken, buildingId) {
  return {
    type: Pre.USERMESSAGE + Actions.MARK_ALL_AS_SEEN,
    accessToken,
    socket: { send: true, keepSocket: true },
    url: `/UserMessages/MarkAllAsSeen?buildingId=${buildingId}`,
  };
}

export function setCountLocally(count) {
  return {
    type: Pre.USERMESSAGE + Actions.NEW_MESSAGES_COUNT,
    payload: { data: JSON.stringify({ count }) },
    socket: { send: false, keepSocket: true },
  };
}

export function getNewMessagesCount(accessToken, buildingId) {
  return {
    type: Pre.USERMESSAGE + Actions.NEW_MESSAGES_COUNT,
    socket: { send: false, keepSocket: true }, // set socket.send = false and set valid url to use http instead of ws
    url: `/UserMessages/NewMessagesCount?buildingId=${buildingId}`,
    accessToken,
  };
}
